<div
  *ngIf="mailEnabled !== undefined"
  nz-tooltip
  nzTooltipTitle="Email notifications are {{ mailEnabled ? 'enabled' : 'disabled' }} {{ tooltipSuffix }}"
  class="flex justify-between items-center gap-8"
>
  <nz-switch
    class="mail-config-switch items-center flex"
    [ngModel]="mailEnabled"
    [nzLoading]="mailStatusLoading"
    [nzControl]="true"
    [nzDisabled]="mailStatusLoading"
    (click)="mailNotificationClicked()"
    [nzCheckedChildren]="checkedMailTemplate"
    [nzUnCheckedChildren]="unCheckedMailTemplate"
  ></nz-switch>
  <span [ngClass]="mailEnabled ? 'text-primary' : 'text-secondary-text'" class="text-sm">Email notifications</span>
</div>

<ng-template #checkedMailTemplate>
  <div class="flex items-center">
    <twaice-fe-svg-icon nz-icon name="check" source="tabler" width="16px" height="16px" />
  </div>
</ng-template>
<ng-template #unCheckedMailTemplate>
  <div class="flex items-center">
    <twaice-fe-svg-icon nz-icon name="x" source="tabler" width="16px" height="16px" />
  </div>
</ng-template>
